import styled from "styled-components";

export const StyledTutorialModalControls = styled.div`
  border-top:  4px solid #708DF7;
  width: 100%;
  padding: 1.625rem;
  display: flex;
  justify-content: space-between;
  align-items: center;background: 
  linear-gradient(180deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0) 100%
  );

  .btn-wrap {
    min-width: 10rem;
  }
`; 